import { useState, useEffect } from 'react';
import { Layout } from './components/Layout';
import { QuickCapture } from './components/QuickCapture';
import { InsightsFeed } from './components/InsightsFeed';
import { GoalProgress } from './components/GoalProgress';
import { ActivityFeed } from './components/ActivityFeed';
import { checkPillarHealth } from './lib/api';
import { Wifi, WifiOff } from 'lucide-react';

function App() {
  const [activeTab, setActiveTab] = useState('capture');
  const [pillarStatus, setPillarStatus] = useState<Record<string, boolean>>({});
  const [isCheckingHealth, setIsCheckingHealth] = useState(true);

  useEffect(() => {
    const checkHealth = async () => {
      setIsCheckingHealth(true);
      const status = await checkPillarHealth();
      setPillarStatus(status);
      setIsCheckingHealth(false);
    };

    checkHealth();
    // Check health every 30 seconds
    const interval = setInterval(checkHealth, 30000);
    return () => clearInterval(interval);
  }, []);

  const allPillarsHealthy = Object.values(pillarStatus).every(Boolean);
  const healthyCount = Object.values(pillarStatus).filter(Boolean).length;
  const totalCount = Object.keys(pillarStatus).length;

  return (
    <Layout activeTab={activeTab} onTabChange={setActiveTab}>
      {/* Health status banner */}
      {!isCheckingHealth && !allPillarsHealthy && (
        <div className="mb-4 card border-yellow-900 bg-yellow-950/30 flex items-center gap-3">
          <WifiOff className="w-5 h-5 text-yellow-500" />
          <div className="flex-1">
            <p className="text-sm text-yellow-400">
              {healthyCount}/{totalCount} pillars online
            </p>
            <p className="text-xs text-yellow-500/70">
              Offline:{' '}
              {Object.entries(pillarStatus)
                .filter(([, healthy]) => !healthy)
                .map(([name]) => name)
                .join(', ')}
            </p>
          </div>
        </div>
      )}

      {!isCheckingHealth && allPillarsHealthy && totalCount > 0 && (
        <div className="mb-4 flex items-center gap-2 text-xs text-gray-500">
          <Wifi className="w-3 h-3 text-green-500" />
          <span>All {totalCount} pillars online</span>
        </div>
      )}

      {/* Tab content */}
      {activeTab === 'capture' && <QuickCapture />}
      {activeTab === 'insights' && <InsightsFeed />}
      {activeTab === 'goals' && <GoalProgress />}
      {activeTab === 'activity' && <ActivityFeed />}
    </Layout>
  );
}

export default App;
